
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-playground-demo-playground"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?type=demo')
};